/* eslint-disable import/no-anonymous-default-export */
export default {

  API_BASE_URL: process.env.REACT_APP_API_URL,
  SHOPIFY_BASE_URL: process.env.REACT_APP_SHOPIFY_URL,
  shopify_customer_connect: "shopify-customer-connect/",
  shopify_oauth_authorize: "shopify/oauth/authorize/",
  stylist_location: "stylist-location/",
  stylist_services: "st-service/",

  check_number: "check-number/",
  otp: "otp/consumer/",
  available_timing: "get-available-timing/",
  booking: "booking/",
  register: "register/",
  payment_methods:"payment-methods/",
  profile:"profile/",
  terms:"terms/",
  privacy_policy:"privacy-policy/",
  timezone:'get-timezone/',
  // Transactions
  stripe_transaction_fee: 'stripe/transaction-fee/',
  setup_intent: 'setup-intent/',
  // Booking API
  get_full_days: 'bookings/full-days/',
  mobile_booking_schedule: 'bookings/mobile/schedule/',
  location_schedule: 'bookings/location/schedule/',
  customer_booking_list: (stylistUniqueCode) => `bookings/stylist/${stylistUniqueCode}/customer/list/`,
  booking_cancel: (id) => `bookings/cancel/${id}/`,
  // AI Booking Agent
  agent_chat_session: 'agent/chat-session/',
  agent_chat: 'agent/chat/',
  agent_tts: 'agent/tts/',
  agent_retell_web_call: 'agent/retell/web-call/',
  agent_verify_otp: 'agent/verify-otp/',
  agent_deposit_payment_intent: 'agent/deposit-payment-intent/',
  agent_confirm_deposit: 'agent/confirm-deposit/',
};
